import { CRYPTO_TRUSTS } from 'stash/constants/investmentTypes';
import queryString from 'query-string';

export function isCryptoTrust(tickerSymbol) {
	return CRYPTO_TRUSTS.includes(tickerSymbol);
}

export const VIEW_TYPE = {
	BASIC_MODAL: 'basic-modal',
};

export const isStateZeroBuyFlow = (viewType) => {
	return viewType === VIEW_TYPE.BASIC_MODAL;
};

export const stateZeroBankLinkRedirectUrl = (cardId) => {
	const returnUrl = buildBuyFlowUrl({
		card_id: cardId,
		viewType: VIEW_TYPE.BASIC_MODAL,
	});
	return `/bank-accounts/new?return-url=${encodeURIComponent(returnUrl)}`;
};

export const onboardingBankLinkRedirectUrl = (queryParams) => {
	const returnUrl = buildOnboardingPurchaseFlowUrl(queryParams);
	return `/bank-accounts/new?return-url=${encodeURIComponent(returnUrl)}`;
};

export const buildOnboardingPurchaseFlowUrl = (queryParams) => {
	return `/onboarding/purchase?${queryString.stringify(queryParams)}&viewType=${
		VIEW_TYPE.BASIC_MODAL
	}`;
};

export const buildBuyFlowUrl = (queryParams) => {
	return `/purchases/new?${queryString.stringify(
		queryParams
	)}&returnCta=Done&returnUrl=/`;
};

export const isStateZeroBuyFlowWithWindow = () => {
	return window.location.pathname.includes(VIEW_TYPE.BASIC_MODAL);
};

export const isStateZeroWithSearchParams = () => {
	return window.location.search.includes(VIEW_TYPE.BASIC_MODAL);
};
